module.exports = __webpack_public_path__ + "static/media/add_contract.95773157.svg";